import { WebBridgeApi } from 'ijsbridge'

export const setWechatShareConfig = (config) => {
  window.shareWexnDescription = config.desc
  window.shareWexnTitle = config.title
  window.shareWexnIcon = config.shareIcon
  window.shareWexnUrl = config.url

  const shareScript = document.querySelector('#wxshare-007')
  if (shareScript) {
    document.body.removeChild(shareScript)
  }
  const wxshare = document.createElement('script')
  wxshare.id = 'wxshare-007'
  wxshare.src = 'https://file.iqilu.com/custom/new/public/js/weixin.js'

  document.body.appendChild(wxshare)
}

// 屏蔽分享
export const useBlockShare = () => {
  WebBridgeApi.requestApi('navigatorConfig', {
    right: null,
    title: '\u200E',
  }).then(({ result, err }) => {
    console.log('result', result)
    console.log('err xxx', err)
  })
}
